module.exports = __webpack_public_path__ + "static/media/bring.232e0840.png";